import { Card, CardHeader, CardTitle, CardContent, Badge, Button } from '@redbax/ui-kit';
import { usePendingDevices, useApproveDevice, useRejectDevice, formatDate } from '@redbax/shared';
import { CheckCircle2, XCircle, Clock } from 'lucide-react';

export function PendingDevicesCard() {
  const { data: devices, isLoading } = usePendingDevices();
  const approveDevice = useApproveDevice();
  const rejectDevice = useRejectDevice();

  if (isLoading || !devices || devices.length === 0) return null;

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5" />
          Awaiting User Sign-in
          <Badge variant="secondary">{devices.length}</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {devices.map((device) => {
            const isPending =
              (approveDevice.isPending && approveDevice.variables === device.id) ||
              (rejectDevice.isPending && rejectDevice.variables === device.id);

            return (
              <div
                key={device.id}
                className="flex items-center justify-between rounded-lg border border-border p-3"
              >
                <div className="space-y-1">
                  <p className="text-sm font-medium">{device.hostname}</p>
                  <p className="text-xs text-text-secondary">
                    {device.platform} &middot; Registered{' '}
                    {formatDate(device.registeredAt)}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Button
                    size="sm"
                    onClick={() => approveDevice.mutate(device.id)}
                    disabled={isPending}
                  >
                    <CheckCircle2 className="mr-1 h-4 w-4" />
                    Approve
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => rejectDevice.mutate(device.id)}
                    disabled={isPending}
                    className="text-status-error border-status-error hover:bg-status-error/10"
                  >
                    <XCircle className="mr-1 h-4 w-4" />
                    Reject
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
